const REQUIRED_UPLOAD_FIELDS = [
  'filelist1',
  'filelist2',
  'filelist3',
  'filelist4',
  'filelist5',
  'filelist6',
  'filelist7',
  'filelist8',
  'filelist9',
  'filelist10',
  'filelist12',
  'filelist_commitment',
]

const PROVINCE_OPTIONS = [
  '北京市',
  '天津市',
  '河北省',
  '山西省',
  '内蒙古自治区',
  '辽宁省',
  '吉林省',
  '黑龙江省',
  '上海市',
  '江苏省',
  '浙江省',
  '安徽省',
  '福建省',
  '江西省',
  '山东省',
  '河南省',
  '湖北省',
  '湖南省',
  '广东省',
  '广西壮族自治区',
  '海南省',
  '重庆市',
  '四川省',
  '云南省',
  '西藏自治区',
  '陕西省',
  '甘肃省',
  '青海省',
  '宁夏回族自治区',
  '新疆维吾尔自治区',
  '香港特别行政区',
  '澳门特别行政区',
  '台湾省',
]

const SMS_FAILURE_CONTACT_TIP = '如通知失败非企业停机、空号、暂停服务、关机、不在服务区的原因造成，请及时联系告知评审办公室。'

function hasValue(value) {
  return value !== undefined && value !== null && String(value).trim() !== ''
}

function hasFile(value) {
  return Array.isArray(value) ? value.length > 0 : !!value
}

function isValidMobile(value) {
  return /^1[3-9]\d{9}$/.test(String(value || '').trim())
}

function normalizeGongfaAuthorNames(authorNames) {
  if (!Array.isArray(authorNames)) return []
  return authorNames
    .map((author) => ({
      ...(author || {}),
      name: String((author && author.name) || ''),
    }))
    .filter((author) => author.name.trim())
}

function isValidGongfaAuthorName(name) {
  const value = String(name || '')
  return value.trim() !== '' && !/[0-9\s]/.test(value)
}

function ensureGongfaEnterpriseInfo(info) {
  const target = info || {}
  if (!hasValue(target.gf_province)) target.gf_province = '1'
  if (!Array.isArray(target.author_names)) {
    target.author_names = []
  }
  while (target.author_names.length < 5) {
    target.author_names.push({ name: '', starttime: '' })
  }
  REQUIRED_UPLOAD_FIELDS.forEach((field) => {
    if (!Array.isArray(target[field])) target[field] = []
  })
  if (target.text_public_authorized === undefined || target.text_public_authorized === null) {
    target.text_public_authorized = ''
  }
  if (target.gf_province_detail === undefined || target.gf_province_detail === null) {
    target.gf_province_detail = ''
  }
  return target
}

function validateGongfaEnterpriseInfo(info) {
  const errors = []
  const value = info || {}

  if (!hasValue(value.name)) errors.push('请输入工法名称')
  if (!hasValue(value.unit)) errors.push('请输入编写单位')
  if (!hasValue(value.username)) errors.push('请输入申报联系人')
  if (!isValidMobile(value.phone)) errors.push('请输入正确的手机号码')
  if (!hasValue(value.gf_province)) errors.push('请选择企业注册地')
  if (String(value.gf_province) === '2' && !hasValue(value.gf_province_detail)) {
    errors.push('请选择企业注册地所在省份')
  }
  const authors = normalizeGongfaAuthorNames(value.author_names)
  if (authors.length !== 5) {
    errors.push('请完整填写五名主要完成人')
  } else if (authors.some((author) => !isValidGongfaAuthorName(author.name))) {
    errors.push('主要完成人姓名不能包含阿拉伯数字或空格')
  }

  REQUIRED_UPLOAD_FIELDS.forEach((field) => {
    if (!hasFile(value[field])) {
      errors.push(field === 'filelist_commitment' ? '请上传承诺书' : '请上传完整申报材料')
    }
  })

  if (value.text_public_authorized !== '1' && value.text_public_authorized !== '0') {
    errors.push('请选择工法文本公开展示授权')
  }

  return {
    valid: errors.length === 0,
    errors: Array.from(new Set(errors)),
  }
}

function getGongfaSubmitSuccessOptions() {
  return {
    title: '提交成功',
    message: '温馨提示：申报时间截止前，企业可自主撤回修改，逾期系统将关闭自主撤回修改通道，请各企业认真核对申报资料，确认无误后提交。',
    confirmButtonText: '我知道了',
  }
}

function normalizeGongfaRecordState(row) {
  const value = row || {}
  const canWithdraw = value.can_withdraw === true || value.can_withdraw === 1
  const canResubmit = value.can_resubmit === true || value.can_resubmit === 1
  const withdrawText = canWithdraw
    ? `可撤回修改${value.withdraw_deadline ? `，截止时间：${value.withdraw_deadline}` : ''}`
    : ''
  const modifyText = value.modify_deadline
    ? `请在 ${value.modify_deadline} 前完成修订并重新提交`
    : ''
  const smsFailedText = value.sms_failed_reason
    ? `短信发送失败：${value.sms_failed_reason}。${SMS_FAILURE_CONTACT_TIP}`
    : ''

  return {
    canWithdraw,
    canResubmit,
    withdrawText,
    modifyText,
    smsFailedText,
    returnType: value.return_type || '',
  }
}

module.exports = {
  PROVINCE_OPTIONS,
  REQUIRED_UPLOAD_FIELDS,
  SMS_FAILURE_CONTACT_TIP,
  ensureGongfaEnterpriseInfo,
  getGongfaSubmitSuccessOptions,
  isValidGongfaAuthorName,
  isValidMobile,
  normalizeGongfaAuthorNames,
  normalizeGongfaRecordState,
  validateGongfaEnterpriseInfo,
}
